// Image utilities for web

// Pick image from file input and convert to base64
export const pickImage = () => {
    return new Promise((resolve, reject) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';

        input.onchange = async (e) => {
            const file = e.target.files[0];
            if (!file) {
                resolve(null);
                return;
            }

            try {
                const base64 = await fileToBase64(file);
                const compressed = await compressImage(base64);
                resolve({ base64: compressed, file });
            } catch (error) {
                reject(error);
            }
        };

        input.click();
    });
};

// Convert file to base64
export const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
};

// Compress image using canvas
export const compressImage = (base64, maxWidth = 800, quality = 0.7) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = base64;
        img.onload = () => {
            const canvas = document.createElement('canvas');
            let width = img.width;
            let height = img.height;

            // Calculate new dimensions
            if (width > maxWidth) {
                height = height * (maxWidth / width);
                width = maxWidth;
            }

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
            resolve(compressedBase64);
        };
    });
};

// Capture image from camera (using getUserMedia)
export const captureImage = async () => {
    try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });

        return new Promise((resolve, reject) => {
            const video = document.createElement('video');
            video.srcObject = stream;
            video.play();

            video.onloadeddata = () => {
                const canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;

                const ctx = canvas.getContext('2d');
                ctx.drawImage(video, 0, 0);

                // Stop the stream
                stream.getTracks().forEach(track => track.stop());

                const base64 = canvas.toDataURL('image/jpeg', 0.8);
                resolve({ base64 });
            };
        });
    } catch (error) {
        console.error('Error capturing image:', error);
        throw error;
    }
};

export default {
    pickImage,
    fileToBase64,
    compressImage,
    captureImage,
};
